import _ from 'lodash'

export const vsName = 'userProfile'

export class UserProfile {
  FirstName: string = ''
  LastName: string = ''
  DisplayName: string = ''
  PropertyIds: number[] = []
  UserAuthId: number | undefined
  UserName: string = ''
  Roles: string[] = []
  Permissions: string[] = []

  constructor(serverProfile: {
    FirstName?: string;
    LastName?: string;
    DisplayName?: string;
    PropertyIds?: number[];
    UserAuthId?: number;
    UserName?: string,
    Roles?: { RoleName: string, Id: number }[],
    Permissions?: { Id: number, PermissionName: string }[]
  }) {
    this.initialize(serverProfile)
  }

  initialize(serverProfile: { FirstName?: string; LastName?: string; DisplayName?: string, PropertyIds?: number[]; UserAuthId?: number; UserName?: string; Roles?: { RoleName: string; Id: number }[]; Permissions?: { Id: number; PermissionName: string }[] }) {
    const vals = serverProfile || {}
    this.FirstName = vals.FirstName ?? ''
    this.LastName = vals.LastName ?? ''
    this.DisplayName = vals.DisplayName ?? ''
    this.PropertyIds = vals.PropertyIds ?? []
    this.UserAuthId = vals.UserAuthId
    this.UserName = vals.UserName ?? ''
    this.Roles = vals.Roles?.map(r => this._normalizeName(r.RoleName)) ?? []
    this.Permissions = vals.Permissions?.map(p => this._normalizeName(p.PermissionName)) ?? []
  }

  isAdmin() {
    return this.Roles.indexOf(this._normalizeName('admin')) > -1
    //return this.profile.Permissions.indexOf(this._normalizeName('admin')) > -1
  }

  isAuthenticated() {
    return !!this.UserAuthId
  }

  hasPermission(permission: string): boolean {
    const name = this._normalizeName(permission)
    return this.isAdmin() || this.Permissions.indexOf(name) > -1
  }

  hasRole(role: string): boolean {
    var name = this._normalizeName(role)
    return this.isAdmin() || this.Roles.indexOf(name) > -1
  }

  _normalizeName(name: string) {
    return name.toLowerCase()
  }
}
